// Copyright (c) 2024 by Audere

import { format, formatDistance } from "date-fns";

export const formatTimestamp = (timestamp: string | number | Date) => {
  return format(timestamp, "eee, PP • h:mm aa");
};

export const getTSDistance = (
  timestampA: string | number | Date,
  timestampB: string | number | Date = new Date()
) => {
  return formatDistance(timestampA, timestampB, { addSuffix: true });
};
